import _ from "lodash";
import React from "react";
import { InputModalBuilder, InputModalBuilderProps } from "./InputModalBuilder";

export type InputModalProps<ObjectType, MutationResponse, MutationVariable> =
  Omit<
    InputModalBuilderProps<ObjectType, MutationResponse, MutationVariable>,
    "children"
  >;

export class InputModal<
  ObjectType = any,
  MutationResponse = any,
  MutationVariable = any
> extends React.PureComponent<
  InputModalProps<ObjectType, MutationResponse, MutationVariable>
> {
  render() {
    return (
      <InputModalBuilder<ObjectType, MutationResponse, MutationVariable>
        {...this.props}
      >
        {(builder) =>
          _.concat(
            [builder.buildCards()],
            _.map(this.props.keys, (__, key) => (
              <div key={"im_f_" + key}>
                {builder.buildField(key as keyof ObjectType)}
              </div>
            ))
          )
        }
      </InputModalBuilder>
    );
  }
}
